
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { NextPage } from 'next';
import { useMutation } from '@apollo/client';
import { useForm, FieldValues } from 'react-hook-form';
import { css } from '@emotion/react';
import { NavBackBtn } from 'public/assets';
import theme from '@styles/theme';
import { useAppDispatch } from '@store/hooks';
import { alertMessage } from '@slices/alertSlice';
import { REGEX, ERROR_MESSAGE } from '@common/values';
import { FIND_PASSWORD_EMAIL } from '@api/user';

import { Button, SPLoading, TextInput } from '@components/commons';
import RegisterLayout from '@components/auth/register/RegisterLayout';

const FindPasswordPage: NextPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const router = useRouter();
  const {
    watch,
    register,
    formState: { errors, isValid },
    handleSubmit,
    setValue,
    trigger,
  } = useForm({ mode: 'onChange' });

  const [findPassword, { loading }] = useMutation(FIND_PASSWORD_EMAIL, {
    onCompleted: (res: any) => {
      const result = res.sendResetLinkWithEmail.ok;

      result &&
        dispatch(
          alertMessage({
            message: t('passfind_popup_title_sent_temporary_password'),
            type: 'info',
          }),
        );
      router.back();
    },
    onError: () => {
      dispatch(
        alertMessage({
          message: t('snslogin_screen_description_check_email_again'),
          type: 'warning',
        }),
      );
    },
  });

  const submitForm = (values: FieldValues) => {
    trigger('email');
    findPassword({
      variables: { email: values.email },
    });
  };

  return (
    <>
      <header css={header}>
        <NavBackBtn
          width={22}
          height={22}
          stroke={theme.colors.gray800}
          className="icon"
          onClick={() => router.back()}
        />
      </header>
      <main css={container}>
        <div className="form">
          <form onSubmit={handleSubmit(submitForm)}>
            <RegisterLayout
              title={t('common_screen_title_input_email')}
              infoText={t('signup_screen_label_send_authentication')}
            >
              <TextInput
                id="email"
                type="text"
                label={t('common_screen_label_email')}
                error={errors?.email?.message}
                showDeleteIcon={watch()?.email}
                register={register}
                onDelete={() => setValue('email', '')}
                placeholder={t('common_screen_label_email')}
                rules={{
                  pattern: {
                    value: REGEX.E_MAIL,
                    message: t(ERROR_MESSAGE.E_MAIL_VALIDATION),
                  },
                }}
              />
            </RegisterLayout>
            <Button
              type="submit"
              title={t('passfind_screen_button_get_temporary_password')}
              customCSS={buttonStyle}
              isDisable={!isValid || !watch()?.email}
            />
          </form>
        </div>
      </main>
      {loading && <SPLoading />}
    </>
  );
};

const buttonStyle = css`
  margin-top: 2.5em;
  width: 100%;
  height: 3rem;
  font-size: 1em;
  cursor: pointer;
  font: ${theme.font.body1Bold};
`;

const header = css`
  position: fixed;
  top: 0;
  display: flex;
  height: 4em;
  width: 50em;
  align-items: center;
  padding: 1.375em 1.25em;
  z-index: 10;
  background: ${theme.colors.white};

  .icon {
    cursor: pointer;
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    width: 100%;
  }
`;

const container = css`
  padding: 4em 1.25em 4em;
  max-width: 800px;
  width: 100%;
  height: 100vh;
  background: ${theme.colors.white};

  .icon {
    cursor: pointer;
  }

  .title {
    font-weight: 700;
    font-size: 1.5em;
    line-height: 1.875em;
    letter-spacing: -0.3px;
    color: ${theme.colors.gray900};
  }

  .content {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: ${theme.colors.gray600};
    margin-top: 8px;
  }

  .subTitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: ${theme.colors.gray700};
    margin-bottom: 24px;
  }
`;

export default FindPasswordPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/findpassword',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  